var map = {
	"./add-icon.svg": "S6Tp",
	"./anquan.svg": "s+ur",
	"./auth.svg": "TnCw",
	"./cart.svg": "kI7G",
	"./circle-icon.svg": "/V0r",
	"./collection.svg": "bAZ4",
	"./double-arrow-right.svg": "WRSv",
	"./exit.svg": "Xbuc",
	"./gift.svg": "PXv6",
	"./image-libary.svg": "J/al",
	"./order.svg": "Ef/C",
	"./personal-center.svg": "Lzd+",
	"./personal-info.svg": "aE+S",
	"./photo.svg": "ZTJu",
	"./photograph.svg": "gr5r",
	"./photographer.svg": "W9d7",
	"./qcode.svg": "ONYm",
	"./qq.svg": "FDDl",
	"./search-by-image.svg": "SfhV",
	"./search-icon.svg": "lhTt",
	"./service.svg": "TgQf",
	"./settlement.svg": "iTrR",
	"./tips-icon.svg": "UkZh",
	"./upload.svg": "nYLW",
	"./wx.svg": "3e4B"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "noFl";